import { c as _c } from "react/compiler-runtime";
import { Accordion } from '@systemeio/components';
import { ChevronDownFilledIcon } from '@systemeio/icons';
import { type ReactNode } from 'react';
import { IconTile } from 'shared/components/icon-tile';
import { CARD_PADDING_CLASSNAME } from 'shared/constants/card-class-names';
import { twMerge } from 'tailwind-merge';
const DISCLOSURE_ITEM_VALUE = 'content';
interface OfferConfigurationDisclosureProps {
  children?: ReactNode;
  defaultOpen?: boolean;
  description?: ReactNode;
  icon: ReactNode;
  onOpenChange?: (open: boolean) => void;
  /** Controls the panel. Leave undefined to let the disclosure own its state. */
  open?: boolean;
  title: ReactNode;
}

/*
 * The offer configuration card whose whole header is the disclosure trigger. The header therefore
 * renders spans rather than the divs `OfferConfigurationCard` uses: a button only takes phrasing
 * content, and for the same reason a `Hint` passed as `title` has to be a passive one.
 */
function OfferConfigurationDisclosure(t0) {
  const $ = _c(32);
  const {
    children,
    defaultOpen,
    description,
    icon,
    onOpenChange,
    open,
    title
  } = t0;
  let t1;
  if ($[0] !== defaultOpen) {
    t1 = defaultOpen ? [DISCLOSURE_ITEM_VALUE] : undefined;
    $[0] = defaultOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onOpenChange) {
    t2 = value => onOpenChange?.(value.includes(DISCLOSURE_ITEM_VALUE));
    $[2] = onOpenChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== open) {
    t3 = open === undefined ? undefined : open ? [DISCLOSURE_ITEM_VALUE] : [];
    $[4] = open;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = twMerge(CARD_PADDING_CLASSNAME, "group justify-between gap-3 font-normal");
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== icon) {
    t5 = <IconTile size="m" tone="gray">{icon}</IconTile>;
    $[7] = icon;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== title) {
    t6 = <span className="text-base font-medium">{title}</span>;
    $[9] = title;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== description) {
    t7 = description && <span className="text-text-tertiary text-sm">{description}</span>;
    $[11] = description;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <span className="flex w-full min-w-0 flex-col gap-1">{t6}{t7}</span>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t5 || $[17] !== t8) {
    t9 = <span className="flex w-full min-w-0 items-center gap-2">{t5}{t8}</span>;
    $[16] = t5;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ChevronDownFilledIcon aria-hidden={true} className="text-icon-primary transition-base size-5 shrink-0 group-data-panel-open:rotate-180" />;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t9) {
    t11 = <Accordion.Header><Accordion.Trigger className={t4}>{t9}{t10}</Accordion.Trigger></Accordion.Header>;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== children) {
    t12 = <Accordion.Panel><Accordion.Content className="tablet:px-5 px-4 pb-5">{children}</Accordion.Content></Accordion.Panel>;
    $[22] = children;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t11 || $[25] !== t12) {
    t13 = <Accordion.Item value={DISCLOSURE_ITEM_VALUE}>{t11}{t12}</Accordion.Item>;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t1 || $[28] !== t13 || $[29] !== t2 || $[30] !== t3) {
    t14 = <Accordion.Root defaultValue={t1} onValueChange={t2} value={t3}>{t13}</Accordion.Root>;
    $[27] = t1;
    $[28] = t13;
    $[29] = t2;
    $[30] = t3;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  return t14;
}
export { OfferConfigurationDisclosure };
export type { OfferConfigurationDisclosureProps };